// Font Awesome Vue Component Custom Library

// Font Awesome Icons
// https://fontawesome.com/icons

// Font Awesome Vue Component
// https://github.com/FortAwesome/vue-fontawesome

// fontawesome
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan'
import { faBan as fatBan } from '@fortawesome/pro-thin-svg-icons/faBan'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
// Sharp large carets (Font Awesome 6+ Sharp Solid)
import { faCaretDown as faSharpCaretDown } from '@fortawesome/sharp-solid-svg-icons/faCaretDown'
import { faCaretRight as faSharpCaretRight } from '@fortawesome/sharp-solid-svg-icons/faCaretRight'
// Large variants
import { faCaretLargeDown } from '@fortawesome/sharp-solid-svg-icons/faCaretLargeDown'
import { faCaretLargeRight } from '@fortawesome/sharp-solid-svg-icons/faCaretLargeRight'
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp'
import { faCube } from '@fortawesome/free-solid-svg-icons/faCube'
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf'
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons'
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faFaceSadTear } from '@fortawesome/pro-duotone-svg-icons/faFaceSadTear'
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass'
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import { faSortDown } from '@fortawesome/pro-duotone-svg-icons/faSortDown'
import { faSortUp } from '@fortawesome/pro-duotone-svg-icons/faSortUp'
import { faSort } from '@fortawesome/pro-duotone-svg-icons/faSort'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
// Outlined version: free regular circle-check (stroke circle + check, transparent fill)
import { faCircleCheck as farCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck'

export default {
  faAngleDown,
  faAngleRight,
  faArrowRight,
  faBan,
  fatBan,
  faCaretDown,
  faCaretRight,
  faSharpCaretDown,
  faSharpCaretRight,
  faCaretLargeDown,
  faCaretLargeRight,
  faCaretUp,
  faCube,
  faDownload,
  faCircleInfo,
  faFilePdf,
  faFolderOpen,
  faGear,
  faPaperPlane,
  faFaceSadTear,
  faMagnifyingGlass,
  faShieldCheck,
  faSort,
  faSortDown,
  faSortUp,
  faStar,
  faTimes,
  farCircleCheck
}
